export default __webpack_public_path__ + "static/media/Portima_Positive-RGB.65805473.png";